import { Box } from '@mui/material';
import { RecentWinnerCard } from 'app/components/AppHeader/RecentWinnerCard';
import { CAROUSEL_AUTO_PLAY_SPEED } from 'app/constants';
import { LeaderboardType } from 'app/enums';
import { RecentWinnerEntity } from 'app/interfaces/entity';
import { apiRequestCall, UrlParams } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';
import { useCancelToken } from 'app/services/api/hooks';
import { AxiosRequestConfig } from 'axios';
import config from 'config/config';
import { CAROUSEL_RESPONSIVE } from 'modules/leaderboards/constants';
import React, { FC, useCallback, useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';

const RECENT_WINNERS_LIMIT = 10;
const RECENT_WINNERS_PARAMS: AxiosRequestConfig & UrlParams = {
  method: 'GET',
  resource: ApiResource.Leaderboards,
  params: {
    offset: 0,
    secondsAgo: 7 * 24 * 3600,
    limit: RECENT_WINNERS_LIMIT,
    type: LeaderboardType.RecentWinners,
  },
};

export const RecentWinners: FC = () => {
  const cancelToken = useCancelToken();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [recentWinners, setRecentWinners] = useState<RecentWinnerEntity[]>([]);

  const getRecentWinnersHandler = useCallback(() => {
    setIsLoading(true);
    apiRequestCall<{ data: RecentWinnerEntity[] }>({
      params: { ...RECENT_WINNERS_PARAMS, cancelToken },
      handlers: {
        success: (winners) => {
          setIsLoading(false);
          setRecentWinners(winners.data);
        },
        error: () => setIsLoading(false),
      },
      rejectOnCancel: false,
    });
  }, [cancelToken, setIsLoading]);

  useEffect(() => {
    getRecentWinnersHandler();

    const interval = setInterval(
      () => getRecentWinnersHandler(),
      config.refreshLeaderboardInterval * 1000
    );

    return () => {
      clearInterval(interval);
    };
  }, [getRecentWinnersHandler]);

  if (isLoading || !recentWinners?.length) {
    return null;
  }

  return (
    <Carousel
      autoPlay
      infinite
      arrows={false}
      swipeable={false}
      draggable={false}
      autoPlaySpeed={CAROUSEL_AUTO_PLAY_SPEED}
      responsive={CAROUSEL_RESPONSIVE}
    >
      {recentWinners.map((winner) => (
        <Box key={winner.user.id}>
          <RecentWinnerCard winner={winner} />
        </Box>
      ))}
    </Carousel>
  );
};
